import { createContext, useContext } from "react";

const SideHeaderContext = createContext(false);

export const useSideHeader = () => useContext(SideHeaderContext);

export default SideHeaderContext;
